import { render, staticRenderFns } from "./CategorySideBar.vue?vue&type=template&id=282e1506"
import script from "./CategorySideBar.vue?vue&type=script&lang=js"
export * from "./CategorySideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports